// extracted by mini-css-extract-plugin
export var editInput = "_h0-0";
export var editInputCompact = "_h0-2";
export var editInputLarge = "_h0-1";
export var editInputSmall = "_h0-3";